// The menu's view, rows or cards, on a restaurant's page (UC-31). The switch
// shows in two places, one by width alone (#1020): under 640 px at the end
// of the «كل المطاعم» row, from 640 px at the end of the pinned category
// row. The worker draws both with its first view pressed, and each one's
// parent hides it on the other side of 640 with CSS, so the place needs no
// script. The two copies are two islands, so the diner's pick lives here,
// once, and both read it; the menu's data-view follows it. The pick holds
// for this page only and is kept nowhere.
//
// The worker renders the page with this module too, and never writes it:
// only a tap does, so every page starts from the worker's first view.

import { keep, onPage } from './anchor';
import { crossing } from './crossing';

export type View = 'list' | 'cards';

const picked = $state<{ view: View | null }>({ view: null });

/** The view the switch shows pressed: the diner's pick, else the worker's. */
export function shown(first: View): View {
	return picked.view ?? first;
}

/** The diner's tap: the menu changes, the item under the bar stays put. */
export function choose(next: View): void {
	keep(onPage(), () => {
		picked.view = next;
		const menu = document.querySelector<HTMLElement>('[data-menu]');
		// Set at once, not in an effect, so the place reads the new layout.
		if (menu) menu.dataset.view = next;
	});
}

let started = false;

/** Called by each copy as it mounts; the page listens once, for both. The
 *  islands are mounted once and never destroyed, so it never stops. */
export function follow(): void {
	if (started) return;
	started = true;
	crossing({
		page: onPage(),
		wide: window.matchMedia('(min-width: 640px)'),
		win: window,
		doc: document,
		frame: (callback) => requestAnimationFrame(callback),
		cancel: (id) => cancelAnimationFrame(id),
	});
}
